export default "__VITE_ASSET__CW2j1XbE__"